import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { fetchItemDetailsAction, fetchMenuAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import { getStoreStatusForTimeSaga } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { ChannelManager } from 'common/manager';
import { formatDateTime, getEpochTime } from 'common/utilities/dayJsUtils';
import {
  getAndCheck,
  getEntireCatNavigation,
  getPrice,
  getValueOrDefaultObject,
  isIpadDevice,
  isMobileDevice,
  toastifyFn,
  goToMenuPage,
} from 'common/utilities/utils';
import HOME_PAGE_CONTAINER_CONSTANTS from 'components/homePageContainer/Constants/homePageContainerConstants';
import { UserOrderContext } from 'context/context';
import { checkStoreAvailablity } from 'organisms/CartPage/Presentation/EmptyCartItems';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/Constants/MenuPDPPageConstants';
import MenusPdpItem from 'organisms/MenuPDPPage/Presentation/MenusPdpItem';
import { ViewPdpProductDetail } from 'organisms/MenuPDPPage/Presentation/ReusableComponents/PdpAnalytics';
import { getTimeIfASAP } from 'organisms/ScheduleOrder/Presentation/ScheduleOrderForm';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductState from '../../MenusPLP/Presentation/ProductState';
import CustomizationAlert from 'organisms/CustomizationAlert/Container/CustomizationAlertContainer';
import { getBrandPageContentCall } from '@kfc-global/react-shared/redux/Actions/BrandPageAction';
import { getCmsClient } from 'common/utilities/cmsClient';
import { BrandPageTemplates } from 'app/Constants';
import { useLocation } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { GeneratedBrandPage } from 'components/BrandPage/BrandPageComponent';

/* check when to call fetch item details API */
export const fetchItemDetailsCall = fetchItemDataParam => {
  const { flatResponse, product_name, tempObj, history, productId, correctCategory } = fetchItemDataParam;

  const { productDetails, tenantData, pdpDeepLinking } = tempObj;
  let selectedProductId = undefined;

  /* fetch category from menuReducer using product_url from urlParams */
  const correctProduct = correctCategory?.productMapByProductUrl?.[product_name];
  if (!correctProduct) {
    goToMenuPage(history);
    return false;
  }

  if (productDetails && tenantData && !pdpDeepLinking) {
    selectedProductId = productDetails.productId;
  } else if (pdpDeepLinking) {
    const filteredItem = flatResponse?.itemMapById?.[productId];
    const filteredProduct = flatResponse?.productMapById?.[productId];
    const itemCheck = filteredProduct?.name === filteredItem?.name;
    selectedProductId = itemCheck && productId;
  }
  return selectedProductId;
};

/* breadcrumb display message */
export const displayBreadcrumbPDP = (categoryId, productId, flatResponse, catalogs) => {
  const category = flatResponse?.categoryMapById?.[categoryId] ?? {};
  const resultString = '';
  const categoryNavigation = category
    ? getEntireCatNavigation(category, flatResponse, [category?.name], catalogs)
    : resultString;
  const product = flatResponse?.itemMapById?.[productId] ?? {};
  return getAndCheck(category, product) ? `${categoryNavigation} > ${product?.dname?.[0]?.value}` : '';
};
/* method to check for catalog & serviceType availablity to decide MenuApi call */
export const checkForCatalogServiceType = (catalogs, serviceType, tenantData) => {
  return catalogs === tenantData?.genericMenuName || (catalogs && serviceType);
};

const menusPdpItemView = (
  productObject,
  tenantObject,
  isMobile,
  category_id,
  product_id,
  product_name,
  flatResponse,
  isStoreClosed,
  catalogs,
  isIpad,
) => {
  return (
    <div className='pdp-container'>
      {productObject && tenantObject?.tenantId && (
        <MenusPdpItem
          tenantData={tenantObject}
          isIpad={isIpad}
          productDetails={productObject}
          isMobile={isMobile}
          displayBreadcrumbPDP={displayBreadcrumbPDP(category_id, product_id, flatResponse, catalogs)}
          isStoreClosed={isStoreClosed}
          product_name={product_name}
        />
      )}
    </div>
  );
};

const viewPdpProductDetail = productDetails => {
  if (productDetails) {
    const analyticsArray = [
      {
        item_name: productDetails?.productInfo?.productName[0]?.value || 'NA',
        item_id: productDetails?.productId || 'NA',
        price: productDetails?.productInfo?.productPrice || 'NA',
        item_category: productDetails?.catalogName || 'NA',
        item_list_name: productDetails?.catalogName || 'NA',
        item_list_id: productDetails?.categoryId || 'NA',
        index: 1,
        quantity: 1,
      },
    ];
    ViewPdpProductDetail(analyticsArray);
  }
};

const MenuPDPContainer = props => {
  const { tenantData, contentData, match, history, setStoreClosedInfo } = props;
  const { params } = match;
  const { category_name = '', product_name = '' } = params;
  const { storeInfo, dispositionType, selectedDate, selectedTime } = contentData;
  const { tenantId, currencyConversionFactor, country } = tenantData;
  const { SET_PDP_DEEPLINK_MODE, RESET_MODGROUP_IDS_UPDATE, YYYYMMDD, YYYYMMDD_hhmm_A } = MENU_PDP_PAGE_CONSTANTS;
  const { PLP_PDP_DETAILS, MENU_URL, CLOSED } = START_ORDER_CONSTANTS;
  const { userOrderStateDispatch, userOrderState } = useContext(UserOrderContext);
  const { pdpDeepLinking, ProductDetails } = userOrderState;
  const { isFromPlp = false } = getValueOrDefaultObject(ProductDetails);
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const [isIpad, setIPadHeader] = useState(isIpadDevice());
  const [product_id, setProductID] = useState('');
  const [category_id, setCategoryId] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const [categoryUrl, setCategoryUrl] = useState('');
  const productDetails = useMemo(() => ProductDetails ?? {}, [ProductDetails]);
  const { SERVICE_CHANNEL } = HOME_PAGE_CONTAINER_CONSTANTS;
  const catalogs = storeInfo?.summary?.menu?.catalogs?.[0] || tenantData?.genericMenuName || '';
  const storeId = storeInfo?.id || '';
  const serviceType = dispositionType;
  const dispatch = useDispatch();
  const { flatResponse = {}, currentItemDetails = {} } = useSelector(({ menuReducer }) => menuReducer) ?? {};
  const storesReducer = useSelector(data => data.storesReducer);
  const { storesTimeSlots } = storesReducer;
  const [isStoreClosed, setIsStoreClosed] = useState(false);
  const location = useLocation();

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    const isIPadWidth = isIpadDevice();
    setMobileHeader(isMobileView);
    setIPadHeader(isIPadWidth);
  };

  useEffect(() => {
    userOrderStateDispatch({ type: RESET_MODGROUP_IDS_UPDATE });
    window.scrollTo(0, 0);
    userOrderStateDispatch({
      type: SET_PDP_DEEPLINK_MODE,
      value: { pdpDeepLinking: !isFromPlp },
    });

    /* check for store closed behaviour */
    if (getAndCheck(selectedDate, selectedTime)) {
      const timeIfAsap = getTimeIfASAP(selectedTime);
      const epochFormat = getEpochTime(formatDateTime(selectedDate, YYYYMMDD) + ' ' + timeIfAsap, YYYYMMDD_hhmm_A);
      const payload = {
        storeid: storeId,
        channel: ChannelManager.channel,
        service: serviceType,
        futureDateTimeInEpochFormat: epochFormat,
      };
      dispatch(getStoreStatusForTimeSaga({ data: payload, tenantId: tenantId }));
    }
    viewPdpProductDetail(productDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* useeffect for checking available time slots for store */
  useEffect(() => {
    if (storesTimeSlots) {
      const currentStoreInfo = { ...storeInfo, summary: storesTimeSlots };
      const {
        futureDates,
        scheduled: initiallyScheduled,
        asap,
      } = getValueOrDefaultObject(currentStoreInfo?.summary?.timings);
      const { unavailibilities } = getValueOrDefaultObject(initiallyScheduled);
      const { interval: initialInterval = 0, startEndTime = {} } = getValueOrDefaultObject(
        initiallyScheduled?.periods?.length && initiallyScheduled?.periods[0],
      );
      const { from, to } = startEndTime;
      const availableSlots = checkStoreAvailablity(
        from,
        to,
        initialInterval,
        asap,
        futureDates,
        country,
        unavailibilities,
      );
      if (storesTimeSlots?.status?.currentStatus === CLOSED && !availableSlots.length) {
        setStoreClosedInfo(currentStoreInfo);
        setIsStoreClosed(true);
        history.push({
          pathname: `${MENU_URL}`,
        });
      } else {
        setIsStoreClosed(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storesTimeSlots]);

  useEffect(() => {
    //call menu api dispatch
    checkForCatalogServiceType(catalogs, serviceType, tenantData) &&
      dispatch(
        fetchMenuAction(
          {
            tenantId: tenantId,
            catalogName: catalogs, //catalogs
          },
          { storeId: storeId, channel: SERVICE_CHANNEL, service: serviceType },
        ),
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeId, serviceType]);

  useEffect(() => {
    if (getAndCheck(product_id === currentItemDetails?.id, pdpDeepLinking)) {
      let productInfo = {
        productImage: currentItemDetails?.imageName,
        productName: currentItemDetails?.dname,
        productPrice: getPrice(currentItemDetails?.availability[0], currencyConversionFactor),
      };
      const ProductDetailsObj = {
        productId: product_id,
        customizable: currentItemDetails?.customizable,
        categoryId: category_id,
        catalogName: flatResponse?.catalogName,
        productInfo: productInfo,
        isFromPlp,
        categoryName: categoryName,
        categoryUrl: categoryUrl,
      };

      userOrderStateDispatch({
        type: PLP_PDP_DETAILS,
        value: ProductDetailsObj,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(currentItemDetails)]);

  const { isBrandPageContentLoading, brandRoutePath } = useSelector(({ brandPageReducer }) => {
    const { isBrandPageContentLoading = false, response: { headerData: { routePath: brandRoutePath } = {} } = {} } =
      brandPageReducer ?? {};
    return {
      isBrandPageContentLoading,
      brandRoutePath,
    };
  });
  const [isBrandPageDispatched, setIsBrandPageDispatched] = useState(false);

  useEffect(() => {
    if (!isEmpty(flatResponse)) {
      const correctItem = flatResponse?.itemMapByUrl?.[product_name] ?? {};
      const correctCategory = flatResponse?.categoryMapByUrl?.[category_name] ?? {};
      setCategoryId(correctCategory?.id);
      setCategoryName(correctCategory?.name);
      setCategoryUrl(correctCategory?.url);
      const productId = correctItem?.id;
      setProductID(productId);

      let tempObj = { history, productDetails, tenantData, pdpDeepLinking };
      const fetchItemDataParam = {
        flatResponse,
        product_name,
        tempObj,
        history,
        productId,
        correctCategory,
      };
      const selectedProductId = fetchItemDetailsCall(fetchItemDataParam);

      if (selectedProductId) {
        dispatch(
          fetchItemDetailsAction({
            tenantId: tenantId,
            catalogName: catalogs,
            itemId: selectedProductId,
          }),
        );
      } else if (pdpDeepLinking && !isBrandPageDispatched && location?.pathname) {
        setIsBrandPageDispatched(true);
        dispatch(
          getBrandPageContentCall({
            object: getCmsClient(),
            contentFull: {
              content_type: BrandPageTemplates.Template2,
              select: 'sys.id,fields',
              'fields.routePath': location?.pathname,
              include: 5,
            },
          }),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(flatResponse), pdpDeepLinking, isBrandPageDispatched, location?.pathname]);

  useEffect(() => {
    if (isBrandPageDispatched && !isBrandPageContentLoading && isEmpty(brandRoutePath)) {
      history.push({
        pathname: `${MENU_URL}`,
      });
      toastifyFn(translateWithI18Next('exploreFoodItem'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBrandPageDispatched, isBrandPageContentLoading, brandRoutePath]);

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [product_id]);

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile, isIpad]);

  if (brandRoutePath) {
    return (
      <>
        <GeneratedBrandPage routePath={location?.pathname} hideNav={true} {...props} />;
      </>
    );
  }
  return (
    <>
      {menusPdpItemView(
        productDetails,
        tenantData,
        isMobile,
        category_id,
        product_id,
        product_name,
        flatResponse,
        isStoreClosed,
        catalogs,
        isIpad,
      )}
      {userOrderState.addToCart && userOrderState.isLocalized && userOrderState.fromPdpPage && (
        <ProductState flatResponse={flatResponse} tenantReducer={tenantData} />
      )}
      {userOrderState.cartAlertData?.showCartAlert && <CustomizationAlert />}
    </>
  );
};
export default MenuPDPContainer;
